__turbopack_context__.v({
  "active": "HeroSlider-module-scss-module__pmYl2a__active",
  "activePage": "HeroSlider-module-scss-module__pmYl2a__activePage",
  "category": "HeroSlider-module-scss-module__pmYl2a__category",
  "container": "HeroSlider-module-scss-module__pmYl2a__container",
  "controls": "HeroSlider-module-scss-module__pmYl2a__controls",
  "cta": "HeroSlider-module-scss-module__pmYl2a__cta",
  "currentProgress": "HeroSlider-module-scss-module__pmYl2a__currentProgress",
  "date": "HeroSlider-module-scss-module__pmYl2a__date",
  "description": "HeroSlider-module-scss-module__pmYl2a__description",
  "headline": "HeroSlider-module-scss-module__pmYl2a__headline",
  "heroSlider": "HeroSlider-module-scss-module__pmYl2a__heroSlider",
  "imageColumn": "HeroSlider-module-scss-module__pmYl2a__imageColumn",
  "markerInner": "HeroSlider-module-scss-module__pmYl2a__markerInner",
  "markerInnerOffset": "HeroSlider-module-scss-module__pmYl2a__markerInnerOffset",
  "markerWrapper": "HeroSlider-module-scss-module__pmYl2a__markerWrapper",
  "navButton": "HeroSlider-module-scss-module__pmYl2a__navButton",
  "navigation": "HeroSlider-module-scss-module__pmYl2a__navigation",
  "pagination": "HeroSlider-module-scss-module__pmYl2a__pagination",
  "paginationDot": "HeroSlider-module-scss-module__pmYl2a__paginationDot",
  "prevArrow": "HeroSlider-module-scss-module__pmYl2a__prevArrow",
  "progressBar": "HeroSlider-module-scss-module__pmYl2a__progressBar",
  "slideContent": "HeroSlider-module-scss-module__pmYl2a__slideContent",
  "slider": "HeroSlider-module-scss-module__pmYl2a__slider",
  "swiper-slide-active": "HeroSlider-module-scss-module__pmYl2a__swiper-slide-active",
  "swiper-slide-thumb-active": "HeroSlider-module-scss-module__pmYl2a__swiper-slide-thumb-active",
  "textColumn": "HeroSlider-module-scss-module__pmYl2a__textColumn",
  "thumbImageWrapper": "HeroSlider-module-scss-module__pmYl2a__thumbImageWrapper",
  "thumbTile": "HeroSlider-module-scss-module__pmYl2a__thumbTile",
  "thumbnailCategory": "HeroSlider-module-scss-module__pmYl2a__thumbnailCategory",
  "thumbnailContent": "HeroSlider-module-scss-module__pmYl2a__thumbnailContent",
  "thumbnailSlide": "HeroSlider-module-scss-module__pmYl2a__thumbnailSlide",
  "thumbnailSwiper": "HeroSlider-module-scss-module__pmYl2a__thumbnailSwiper",
  "thumbnailSwiperWrapper": "HeroSlider-module-scss-module__pmYl2a__thumbnailSwiperWrapper",
  "thumbnailTitle": "HeroSlider-module-scss-module__pmYl2a__thumbnailTitle",
});
